import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import client from "@/lib/api";

export default function CasesSection() {
  const [cases, setCases] = useState([]);

  useEffect(() => {
    client.get("/cases").then(({ data }) => setCases(data)).catch(() => {});
  }, []);

  if (!cases.length) return null;

  return (
    <section data-testid="cases-section" className="bg-gema-black py-24 md:py-32 border-t border-white/5">
      <div className="container-gema">
        <Reveal>
          <SectionLabel index="05">Casos de Éxito</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="heading-lg text-white mt-6 max-w-3xl">
            Nuestra experiencia habla por nosotros
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-white/50 mt-6 max-w-2xl leading-relaxed">
            Cada proyecto refleja nuestro compromiso con la calidad, el cumplimiento y la satisfacción de nuestros clientes.
          </p>
        </Reveal>

        <RevealGroup className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
          {cases.map((c) => (
            <RevealItem key={c.id}>
              <article
                data-testid={`case-card-${c.id}`}
                className="group relative overflow-hidden border border-white/10 h-[380px]"
              >
                <img
                  src={c.image}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
                <div className="relative z-10 h-full flex flex-col justify-end p-8">
                  <span className="inline-block w-fit font-mono text-[10px] uppercase tracking-[0.2em] text-white bg-gema-red px-3 py-1">
                    {c.sector}
                  </span>
                  <h3 className="font-heading font-bold uppercase text-xl text-white mt-4">{c.title}</h3>
                  <p className="text-white/60 text-sm mt-2 leading-relaxed">{c.description}</p>
                  {c.result && (
                    <p className="flex items-center gap-2 text-gema-red text-sm mt-4 font-medium">
                      <ArrowUpRight className="h-4 w-4" /> {c.result}
                    </p>
                  )}
                </div>
              </article>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
